import { ETaskStatus } from '@constants';
import { ISection, ITask } from '@sdk/contracts';

export const calculateCourseTasksProgress = (sections: ISection[]) => {
  const allTasks: ITask[] = sections
    .flatMap(section => section.activities)
    .filter(activity => activity.task !== undefined)
    .flatMap(activity => activity.task as ITask);

  const totalTasks = allTasks.length;
  const completedTasks = allTasks.reduce((acc, task) => {
    const completed = task?.statusInfo.currentStatus === ETaskStatus.APPROVED;
    return completed ? ++acc : acc;
  }, 0);

  return totalTasks === 0
    ? 0
    : Math.round((completedTasks / totalTasks + Number.EPSILON) * 10000) / 100;
};
